/* ==========================================================================
   ASURA — Portada con galería viva (sections/asura-portada.liquid)
   Releva las fotos cada N segundos con un fundido; el acercamiento lento lo
   pone el CSS (.is-activa). Se detiene fuera de pantalla, con la pestaña en
   segundo plano y con "reducir movimiento". Los puntos llevan a cada foto.
   ========================================================================== */
(function () {
  var quieto = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function iniciar(raiz) {
    if (!raiz || raiz.getAttribute('data-asura-lista')) return;
    raiz.setAttribute('data-asura-lista', '1');

    var fotos = Array.prototype.slice.call(raiz.querySelectorAll('[data-foto]'));
    var puntos = Array.prototype.slice.call(raiz.querySelectorAll('[data-punto]'));
    if (fotos.length < 2) return;

    var ms = parseInt(raiz.getAttribute('data-intervalo'), 10) || 6000;
    var actual = 0;
    var reloj = null;
    var visible = true;

    function mostrar(n) {
      actual = (n + fotos.length) % fotos.length;
      fotos.forEach(function (foto, k) {
        foto.classList.toggle('is-activa', k === actual);
        foto.setAttribute('aria-hidden', k === actual ? 'false' : 'true');
      });
      puntos.forEach(function (punto, k) {
        punto.classList.toggle('is-activo', k === actual);
        punto.setAttribute('aria-current', k === actual ? 'true' : 'false');
      });
    }

    function siguiente() {
      var n = (actual + 1) % fotos.length;
      var img = fotos[n].querySelector('img');
      // si la siguiente foto no ha terminado de cargar, espera a que llegue
      if (img && !img.complete) {
        img.loading = 'eager';
        img.addEventListener('load', function () { mostrar(n); }, { once: true });
        return;
      }
      mostrar(n);
    }

    function parar() {
      if (reloj) {
        clearInterval(reloj);
        reloj = null;
      }
    }

    function arrancar() {
      parar();
      if (quieto.matches || document.hidden || !visible) return;
      reloj = setInterval(siguiente, ms);
    }

    puntos.forEach(function (punto, k) {
      punto.addEventListener('click', function () {
        mostrar(k);
        arrancar();
      });
    });

    document.addEventListener('visibilitychange', arrancar);
    if (quieto.addEventListener) quieto.addEventListener('change', arrancar);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        arrancar();
      }).observe(raiz);
    } else {
      arrancar();
    }

    // en cuanto la portada está lista, se piden las demás fotos
    window.addEventListener('load', function () {
      fotos.forEach(function (foto) {
        var img = foto.querySelector('img');
        if (img) img.loading = 'eager';
      });
    }, { once: true });
  }

  function todas() {
    document.querySelectorAll('[data-asura-portada]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todas);
  } else {
    todas();
  }

  // editor de temas: al recargar la sección
  document.addEventListener('shopify:section:load', todas);
})();
